@if (manager.contentState() === 'none') {
  <albert-content-unit-cta-button/>
} @else if (manager.contentState() === 'view' || manager.contentState() === 'edit' || manager.contentState() === 'create') {
  <albert-content-unit-display/>
}
